var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoTransactions(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 188,
    viewBox: "0 0 200 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49.8941 30.5334C78.7199 45.9992 90.7149 -0.999994 109.715 18.5C128.715 38 171.715 21.5 180.215 52C188.715 82.5 164.7 63.5 177.215 121C189.73 178.5 147.884 146.618 116.215 166C84.5458 185.382 55.7149 149 29.2149 154.5C2.71495 160 -2.28509 118 17.7149 104C37.715 90 16.156 68.0875 11.1599 59.7468C3.9528 47.7177 21.0682 15.0675 49.8941 30.5334Z",
    fill: "#D6DAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.248 56.5498V135.208C151.248 139.93 147.794 143.758 143.533 143.758H51.7157C47.4544 143.758 44 139.93 44 135.208V56.5498M151.248 56.5498C151.248 51.8279 147.794 48 143.533 48H51.7157C47.4544 48 44 51.8279 44 56.5498M151.248 56.5498V73.6493H44V56.5498M114.985 72.7944V142.048M80.2639 72.7944V142.048M151.248 118.963L44 118.963M151.248 95.8788L44 95.8788",
    stroke: "#515C6F",
    strokeWidth: 5.10707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.944 88.1928C163.277 95.5814 165.664 109.947 158.275 120.28C152.305 128.629 141.785 131.787 132.514 128.799L118.213 148.798C116.125 151.718 112.065 152.393 109.145 150.305C106.225 148.217 105.551 144.157 107.639 141.237L121.768 121.477C115.338 113.633 114.675 102.169 120.857 93.5237C128.246 83.191 142.612 80.8043 152.944 88.1928ZM145.961 97.9596C141.022 94.4281 134.156 95.5689 130.624 100.508C127.093 105.446 128.233 112.313 133.172 115.844C138.111 119.376 144.977 118.235 148.509 113.296C152.04 108.357 150.899 101.491 145.961 97.9596Z",
    fill: "#556E98",
    stroke: "#EFF0F3",
    strokeWidth: 6
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransactions);
export default __webpack_public_path__ + "static/media/no-transactions.cac60535282c955bf0703f19a588c805.svg";
export { ForwardRef as ReactComponent };